import {
    ChevronDownIcon,
    ChevronUpIcon,
} from '../../Icon'
import React from 'react'
import {isEmpty} from 'api/event'
import styles from './styles/DropdownButtonView.module.scss'
import {useDropdownMenuContext} from '../DropdownContext/dropdownContext'

interface DropdownButtonProps {
    caret?: boolean | null;
    classes?: string;
    children?: React.ReactElement | React.ReactElement[];
    customClass?: 'action' | 'sidebar' | null;
    disabled?: boolean;
    hasActivity?: boolean | null;
    hasHighlight?: boolean | null;
    tabIndex?: number
    title?: string;
}

const DropdownButtonView: React.FC<DropdownButtonProps> = (props: DropdownButtonProps): React.ReactElement => {
    const {
        caret,
        children,
        classes,
        customClass,
        disabled,
        hasActivity,
        hasHighlight,
        tabIndex,
        title,
        ...rest
    } = props

    const {
        isOpen, onToggle,
    } = useDropdownMenuContext()

    isEmpty(rest)

    return (
        <div className={`
            ${styles.DropdownButtonView}
            ${isOpen ? styles.open : ''}
            ${classes}
            ${customClass ? styles[customClass] : ''}
            ${hasActivity ? styles.activity : ''}
            ${hasHighlight ? styles.highlight : ''}`}
        >
            <button
                aria-expanded={isOpen}
                aria-haspopup='true'
                className='rowParent'
                data-name='dropdown-button'
                disabled={disabled}
                onClick={() => onToggle()}
                tabIndex={tabIndex}
                title={title}
                type='button'
            >
                {children}
                {!!isOpen && !!caret &&
                    <ChevronUpIcon />}
                {!isOpen && !!caret &&
                    <ChevronDownIcon />}
            </button>
        </div>
    )
}

DropdownButtonView.defaultProps = {
    caret: true,
    children: [],
    classes: '',
    customClass: null,
    disabled: false,
    hasActivity: false,
    hasHighlight: false,
    tabIndex: undefined,
    title: '',
}


export default DropdownButtonView
